/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilesystemPermissionPartialUpdate
 */
export interface FilesystemPermissionPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof FilesystemPermissionPartialUpdate
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemPermissionPartialUpdate
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FilesystemPermissionPartialUpdate
     */
    user?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FilesystemPermissionPartialUpdate
     */
    group?: number | null;
}

export function FilesystemPermissionPartialUpdateFromJSON(json: any): FilesystemPermissionPartialUpdate {
    return FilesystemPermissionPartialUpdateFromJSONTyped(json, false);
}

export function FilesystemPermissionPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilesystemPermissionPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': !exists(json, 'path') ? undefined : json['path'],
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'group': !exists(json, 'group') ? undefined : json['group'],
    };
}

export function FilesystemPermissionPartialUpdateToJSON(value?: FilesystemPermissionPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'read_only': value.readOnly,
        'user': value.user,
        'group': value.group,
    };
}


